export const toastViewportClasses = [
    'ideo-toast-viewport pointer-events-none !z-[1200] !w-[min(420px,calc(100vw-32px))] !p-0 !font-sans',
    '[perspective:1200px]',
    'max-md:!top-[12px] max-md:!right-[12px] max-md:!left-[12px] max-md:!w-[calc(100vw-24px)] max-md:!transform-none'
].join(' ');

export const toastItemClasses = [
    'ideo-toast-item pointer-events-auto !w-full !overflow-visible !border-0 !bg-transparent !p-0 !shadow-none',
    '![transition:transform_0.55s_cubic-bezier(.16,1.1,.3,1),opacity_0.35s_cubic-bezier(.16,1,.3,1),height_0.5s_cubic-bezier(.16,1.1,.3,1)]',
    'data-[mounted=false]:![--y:translateY(0)] data-[mounted=false]:!opacity-100 data-[mounted=true]:!opacity-100',
    'data-[expanded=false]:data-[front=false]:![--y:translateY(calc(var(--toasts-before)_*_14px))_scale(calc(1_-_var(--toasts-before)_*_0.05))]',
    'data-[expanded=false]:data-[index=1]:!opacity-[0.72] data-[expanded=false]:data-[index=2]:!opacity-[0.42] data-[expanded=false]:data-[index=3]:!opacity-0',
    'data-[removed=true]:![--y:translateY(calc(var(--offset)_-_70%))_scale(.9)] data-[removed=true]:!opacity-0',
    'data-[removed=true]:![transition:transform_0.24s_cubic-bezier(.32,0,.67,0),opacity_0.24s_cubic-bezier(.32,0,.67,0)]',
    'focus-visible:!outline-[2px] focus-visible:!outline-offset-[2px] focus-visible:!outline-accent',
    'motion-reduce:!transition-none'
].join(' ');
